"use client";
import useSearchModal from "../useSearchModal";
import styles from "./backdrop.module.css";

const SearchBackdrop = () => {
  const { isOpen, closeModal } = useSearchModal();
  return (
    <>{isOpen && <div className={styles.backdrop} onClick={closeModal} />}</>
  );
};

export default SearchBackdrop;
